export const RELATIVE_DATE_PERIODS = [
  'RELATIVE_DAY',
  'RELATIVE_WEEK',
  'RELATIVE_MONTH',
  'RELATIVE_QUARTER',
  'RELATIVE_YEAR',
] as const;
